<template>
    <li
        class="app-dropdown-item"
        :class="{ selected: isSelected }"
        @click.prevent.stop.capture="toggle()"
        :style="{ 'font-size': fontSize }"
    >
        <app-checkbox v-if="showCheckbox" :checked="isSelected">
            <span v-html="details.label"></span>
        </app-checkbox>

        <span v-else v-html="details.label"></span>
    </li>
</template>
<script lang="ts">
import { AppDropdownOptionComponent } from "./app-dropdown-option";
export default AppDropdownOptionComponent;
</script>
